import { render, staticRenderFns } from "./add_project.vue?vue&type=template&id=33275366&scoped=true&"
import script from "./add_project.vue?vue&type=script&lang=js&"
export * from "./add_project.vue?vue&type=script&lang=js&"
import style0 from "./add_project.vue?vue&type=style&index=0&id=33275366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33275366",
  null
  
)

export default component.exports